import React from 'react';
import classNames from 'classnames';
export default class Switcher extends React.Component {

  state = { checked: false, inputValue: '' };

  componentWillMount = () => {
    this.setState({value: this.props.value})
  };

  hasError = () => {
    return this.state.error;
  };

  componentWillReceiveProps = newProps => {
    this.setState({value: newProps.value, errors: newProps.errors, inputValue: newProps.inputValue})
  };

  onChangeSwitcher = e => {
    if(this.props.reversed) {
      this.props.handleChange({[this.props.name]: this.state.value});
    } else {
      this.props.handleChange({[this.props.name]: !this.state.value});
    }
  };

  addSwitchedInput = e => {
    this.props.handleChange({[this.props.inputName]: e.target.value})
  };

  isArray = () => {
    if(this.state.errors)
      return Array.isArray(this.state.errors.slice());
    else
      return false
  };

  getError = () => {
    let err;
    switch(this.props.name){
      case 'cpd_hours':
        err = 'Empty';
        break;
      case 'fee':
        err = 'Empty';
        break;
      case 'tickets_limit':
        err = 'Empty';
        break
    }
    return err;
  };

  getUnderneathPlaceholder = () => {
    let err;
    switch(this.props.name){
      case 'cpd_hours':
        err = <span className="error-text attention-message" style={{display: 'block', color: !this.isArray() ? 'rgba(0, 0, 0, 0.54)': '#e91e63', marginTop: 8}}>Hours</span>;
        break;
      case 'fee':
        err = <span className="error-text attention-message" style={{display: 'block', color: !this.isArray() ? 'rgba(0, 0, 0, 0.54)': '#e91e63', marginTop: 8}}>Price in <span className="currency euro"/> </span>;
        break
    }
    return err;
  };

  render(){
    return(
      <div className="accordion-content-block with-switcher">
        <p className="label">{this.props.placeholder}</p>
        {!this.props.hideInput ?
          <div className="with-switcher-inner">
              <span className={classNames({'label-sub': true, 'non-display': this.state.value}) }>{this.props.notChoosenText}</span>
              <div className={classNames({'input-holder': true, 'animate': true, 'has-error': this.state.errors, 'non-display': !this.state.value}) }>
                <input className="animate-input"  type="text" value={this.state.inputValue} onChange={this.addSwitchedInput}/>
                <span className="bar"/>
                {this.getUnderneathPlaceholder()}
              </div>

            <div className="switcher" >
              <input
                type="checkbox"
                onChange={this.onChangeSwitcher}
                disabled={this.props.disabledSwitcher}
                id={this.props.name}
                name={this.props.name}
                checked={this.state.value}
              />
              <label htmlFor={this.props.name} />
            </div>
          </div>
        :
        <div className="with-switcher-inner">
          {this.props.leftTitle &&
            <p className="label" style={{margin: '0 10px 0 0'}}>{this.props.leftTitle}</p>
          }
          <div className="switcher" >
            <input
              type="checkbox"
              onChange={this.onChangeSwitcher}
              id={this.props.id}
              name={this.props.name}
              checked={this.state.value}
            />
            <label htmlFor={this.props.id} />
          </div>
          {this.props.rightTitle &&
            <p className="label" style={{margin: '0 0 0 10px'}}>{this.props.rightTitle}</p>
          }
        </div>
      }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/Switcher.jsx